module.exports = __webpack_public_path__ + "static/media/(V)_MG_6066_-_Cia_Termal_Beachewear_-_Moda_Bebe.6153ee91.jpg";